<script setup lang="ts">
import { useI18n } from "vue-i18n";
import type { ScanErrorState } from "@/types/views/captureView.type";

defineProps<{
  isAnalyzing?: boolean;
  progressMessage?: string | null;
  scanError?: ScanErrorState | null;
}>();

const emit = defineEmits<{
  (e: "retry"): void;
}>();

const { t } = useI18n();
</script>

<template>
  <div>
    <div v-if="isAnalyzing" class="scan-loading mt-4">
      <v-progress-circular indeterminate size="32" width="3" color="#559a1b" />
      <p class="mt-2">{{ progressMessage || t("views.captureView.scan.progressFallback") }}</p>
    </div>

    <div v-else-if="scanError" class="scan-error mt-4">
      <h3>{{ scanError.title }}</h3>
      <p>{{ scanError.description }}</p>
      <v-btn class="btn-primary" rounded="xl" height="44" @click="emit('retry')">
        {{ t("views.captureView.scan.retry") }}
      </v-btn>
    </div>

    <template v-else>
      <h2 class="mb-2" style="line-height: 1.2">
        {{ t("views.captureView.scan.title") }}
      </h2>
      <p>{{ t("views.captureView.scan.description") }}</p>
    </template>
  </div>
</template>

<style>
.scan-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  color: #559a1b;
}

.scan-error {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 0;
}

.scan-error h3 {
  margin: 0;
  font-size: 18px;
}

.scan-error p {
  margin: 0;
  color: #525252;
}
</style>
